import { useCallback, useEffect, useState } from 'react';
import { getBatchData, getBatchPrivacyData } from '../services/siteData';

export enum DataType {
  object,
  array
}

export default function useContainData() {
  const [sourceData, setSourceData] = useState();
  const [arrSource, setArrSource] = useState([]);
  const [privacySource, setPrivacy] = useState([]);

  const adNews = useCallback(async () => {
    try {
      const data = await getBatchData();
      const keys = Object.keys(data);
      const sourceObj = [];
      setSourceData(data);
      keys.forEach((item) => {
        sourceObj.push(data?.[item]);
      });
      setArrSource(sourceObj);
      // console.log('请求数据：', data, keys, sourceObj);
    } catch (e) {
      // console.log(e);
    }
  }, []);

  const getCurrentData = useCallback(
    (idx, type: DataType = DataType.array) => {
      if (
        arrSource[idx]?.advertisements &&
        arrSource[idx]?.advertisements?.length >= 1 &&
        type === DataType.array
      ) {
        return arrSource[idx]?.advertisements || [];
      }

      if (arrSource[idx]?.page_news && type === DataType.array) {
        return arrSource[idx]?.page_news || [];
      }

      if (
        arrSource[idx]?.advertisements &&
        arrSource[idx]?.advertisements?.length >= 1 &&
        type === DataType.object
      ) {
        return arrSource[idx]?.advertisements?.[0] || {};
      }
      return type === DataType.array ? [] : arrSource[idx] || {};
    },
    [arrSource]
  );
  // 获取隐私协议列表
  // const postPrivacy = useCallback(async () => {
  //   const data = await getBatchPrivacyData();

  //   const keys = Object.keys(data);
  //   const sourceObj = [];
  //   keys.forEach((item) => {
  //     sourceObj.push(data?.[item]);
  //   });
  //   setPrivacy(sourceObj);
  // }, []);
  useEffect(() => {
    try {
      adNews();
      // postPrivacy();
    } catch (e) {
      // console.log(e, 'error');
    }
  }, [adNews]);
  return {
    sourceData,
    arrSource,
    // privacySource,
    getCurrentData
  };
}
